import { useSearchBenchmarksQuery, useSearchCollectionsQuery } from '@vizit/api';

/**
 * Totals shown on the Collections / Benchmarks switch: every collection and
 * every benchmark in the workspace, regardless of the active filters.
 *
 * The collection total is read from a one-item page, so it costs a single
 * small request. The benchmark total is the list's `Vizit-Total-Count`, from
 * the query the unfiltered Benchmarks view shares, so it usually comes from
 * cache and still counts benchmarks beyond the loaded page.
 */
function useCollectionsViewCounts({ workspaceId, isEnabled }: { workspaceId?: string; isEnabled: boolean }) {
  const enabled = isEnabled && !!workspaceId;

  const { data: collectionCount } = useSearchCollectionsQuery(
    { workspace_id: workspaceId ?? '', limit: 1, offset: 0 },
    { enabled, select: (result) => result.total_count },
  );

  const { data: benchmarkCount } = useSearchBenchmarksQuery(
    { workspace_id: workspaceId ?? '', sort_by: 'created_at', sort_direction: 'desc' },
    { enabled, select: (result) => result.total_count },
  );

  return { collectionCount, benchmarkCount };
}

export { useCollectionsViewCounts };
